import { COLORS } from '@btime/constants'
import React from 'react'

import Grid from './Grid'
import Text from './Text'

const IndexItem = ({ label, name, page = 0 }) => {
  const style = {
    wrapper: {
      textDecoration: 'none',
      display: 'block',
      padding: '1px 0'
    },
    line: {
      borderBottom: `1px dashed ${COLORS.dark3}`,
      flex: 1
    }
  }

  return (
    <a style={style.wrapper} href={name && `#${name}`}>
      <Grid align="flex-bottom">
        <Text>{label}</Text>
        <div style={style.line} />
        {page && <Text>{page}</Text>}
      </Grid>
    </a>
  )
}

export default IndexItem
